import { ImageUpload } from '@/components/form';
import { Input } from '@/components/ui/input';
import ImagePlaceholder from './ImagePlaceholder';

interface ImageProps {
  value: string;
  onChange: (value: string) => void;
  onFocus?: (id: string, value: string) => void;
  id: string;
  placeholder?: string;
}

function Image({ value, onChange, onFocus, id, placeholder }: ImageProps) {
  const handleFocus = () => {
    onFocus?.(id, value || '');
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        {value ? <img className="h-auto w-40" src={value} alt="Store config image" /> : <ImagePlaceholder />}
        <div className="flex flex-grow flex-col gap-2">
          <Input
            placeholder={placeholder || 'Enter image URL'}
            id={id}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            onFocus={handleFocus}
          />
          <ImageUpload url={value} onImageAvailable={(url) => onChange?.(url)} onFocus={handleFocus} />
        </div>
      </div>
    </div>
  );
}

export default Image;
